'use strict';

const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');
const baggageOptionsCollection = require('../collections/baggages_row_options').getInstance();
const baggageCollectionBuilder = require('../builders/baggages').getInstance();
const baggagesObserverMixin = require('../mixins/baggages_observer.mixin');
const trackingUtils = require('../utils/tracking.utils');
const {trackNag} = require('od-modules/track_events/catalog/nags');
module.exports = Odigeo.View.extend(baggagesObserverMixin.extend({
    HIDE_SUCCESS_MESSAGE: 3000,
    smartNagLightbox: null,
    trackingConst: {
        noSegments: '0',
        allSegments: 'ALL',
        departure: '1',
        return: '2',
    },
    selectors: {
        smartnagBaggageSelectMobile: '.smartnag_baggage_select_mobile',
        smartnagBaggageContainer: '.smart_nag_baggage_container',
        smartnagDesktopContainer: '.smart_nag_desktop_container',
        smartnagBaggageContent: '.smartnag_content',
        smartnagSuccess: '.smartnag_success',
        expandButtonContainer: '.expand_btn_container',
        changeButton: '.expand_btn',
        submitNoSelectionButton: '.nag_btn_ignore',
        submitWithSelectionButton: '.nag_btn_action',
        submitWithSelectionButtonEnabled: '.nag_btn_action:not(.disabled)',
        collapsedContainer: '.collapsed_container',
        expandedContainer: '.expanded_container',
        collapsedRowContainer: '.collapsed_baggage_row_container',
        departureRowContainer: '.departure_baggage_row_container',
        returnRowContainer: '.return_baggage_row_container',
        smartnagTitle: '.smartnag_title',
        smartnagHeaderSubtitle: '.smartnag_header_subtitle',
        smartnagHeaderImage: '.smartnag_header_img',
        totalPriceLabel: '.smartnag_total_price',
        totalPrimePriceLabel: '.smartnag_total_prime_price',
        totalPriceRow: '.smartnag_price_row',
        specialSelectContainer: '.special_select_container',
        specialSelectDropdownItem: '.special_select_dropdown_item',
        smartnagPaxIcon: '.smartnag_icon',
        smartnagTitleWrapper: '.smartnag_title_wrapper',
        smartnagSubtitleWrapper: '.smartnag_subtitle',
    },
    events: {
        'tap @changeButton': 'onTapChangeButton',
        'tap @submitNoSelectionButton': 'onTapSubmitNoSelectionButton',
        'tap @submitWithSelectionButtonEnabled': 'onTapSubmitWithSelectionButtonEnabled',
        'tap @smartnagBaggageSelectMobile': 'onTapSmartnagBaggageSelectMobile',
        'change @smartnagBaggageSelectMobile': 'onChangeSmartnagBaggageSelectMobile',
        'tap @specialSelectContainer': 'onTapSpecialSelectContainer',
        'tap @specialSelectDropdownItem': 'onTapSpecialSelectDropdownItem',
        'tap @smartnagDesktopContainer': 'onTapSmartnagDesktopContainer',
    },
    tmpls: {
        mainTemplate: '.smart_nag_baggage_template',
        itemTemplate: '.smart_nag_baggage_item_tmpl',
    },

    onTapChangeButton: function() {
        this.expandReturnSection();
    },
    getMaxdsc({isPrimeView, discountPercentage, discountAmount}, merchandisingDiscountPercentage) {
        if (isPrimeView) {
            return discountAmount > 0 ? `${discountAmount}-abs` : `${discountPercentage}-per`;
        }

        return `${merchandisingDiscountPercentage}-per`;
    },
    onTapSmartnagBaggageSelectMobile: function(event) {
        var $el = $(event.currentTarget);
        const primeInfo = this.getPrimeInfo();
        const {isPrimeView, isPrimeUser} = primeInfo;
        const {displayed: merchandisingDiscountDisplayed = false, discount: merchandisingDiscount = 0}
            = baggageCollectionBuilder.getMerchandisingDiscountInfo();
        const merchandisingDiscountPercentage = merchandisingDiscountDisplayed ? merchandisingDiscount : 0;
        this.trackEvent('nag-baggage-submit',
            {
                'click': $el.prop('selectedIndex') === 0 ? 'add' : 'edit',
                'pax': this.model.getPassengerCount(),
                'prime': isPrimeView && isPrimeUser ? 'yes' : isPrimeView ? 'no' : 'na',
                'maxdsc': this.getMaxdsc(primeInfo, merchandisingDiscountPercentage),
            });
    },
    onChangeSmartnagBaggageSelectMobile: function(event) {
        this.onSelectBaggage($(event.currentTarget), true);
    },
    onTapSubmitNoSelectionButton: function(event) {
        event.stopPropagation();
        event.preventDefault();
        this.smartNagLightbox.remove();
        const primeInfo = this.getPrimeInfo();
        const {isPrimeView, isPrimeUser} = primeInfo;
        const {displayed: merchandisingDiscountDisplayed = false, discount: merchandisingDiscount = 0}
            = baggageCollectionBuilder.getMerchandisingDiscountInfo();
        const merchandisingDiscountPercentage = merchandisingDiscountDisplayed ? merchandisingDiscount : 0;
        this.trackEvent('nag-baggage-submit_continue',
            {
                'pax': this.model.getPassengerCount(),
                'prime': isPrimeView && isPrimeUser ? 'yes' : isPrimeView ? 'no' : 'na',
                'maxdsc': this.getMaxdsc(primeInfo, merchandisingDiscountPercentage),
            });
        trackClickEvent(event);
        this.widget.proceedToPayment();
    },
    onTapSubmitWithSelectionButtonEnabled: function(event) {
        event.stopPropagation();
        event.preventDefault();
        this.setSuccessMessage();
        this.showSuccessMessage();

        const primeInfo = this.getPrimeInfo();
        const {isPrimeView, isPrimeUser} = primeInfo;
        const {displayed: merchandisingDiscountDisplayed = false, discount: merchandisingDiscount = 0}
            = baggageCollectionBuilder.getMerchandisingDiscountInfo();
        const merchandisingDiscountPercentage = merchandisingDiscountDisplayed ? merchandisingDiscount : 0;
        this.trackEvent('nag-baggage-submit_add',
            {
                'pax': this.model.getPassengerCount(),
                'prime': isPrimeView && isPrimeUser ? 'yes' : isPrimeView ? 'no' : 'na',
                'maxdsc': this.getMaxdsc(primeInfo, merchandisingDiscountPercentage),
            });
        trackClickEvent(event);

        Odigeo._.delay(Odigeo._.bind(function() {
            this.smartNagLightbox.remove();
            this.widget.updateBaggageAndProceedToPayment();
        }, this), this.HIDE_SUCCESS_MESSAGE);
    },

    onTapSpecialSelectContainer: function(event) {
        event.stopPropagation();
        event.preventDefault();
        var $el = $(event.currentTarget);
        var rowCids = $el.data('row');
        var $dropdown = this.$el.find('.special_select_' + rowCids);
        var isDropdownHidden = $dropdown.hasClass('odf-hidden');
        this.closeAllSpecialSelectDropdown();
        $dropdown.toggleClass('odf-hidden', !isDropdownHidden);
        const primeInfo = this.getPrimeInfo();
        const {isPrimeView, isPrimeUser} = primeInfo;
        const {displayed: merchandisingDiscountDisplayed = false, discount: merchandisingDiscount = 0}
            = baggageCollectionBuilder.getMerchandisingDiscountInfo();
        const merchandisingDiscountPercentage = merchandisingDiscountDisplayed ? merchandisingDiscount : 0;
        this.trackEvent('nag-baggage-submit',
            {
                'click': $el.data('selected') === 'selected' ? 'edit' : 'add',
                'pax': this.model.getPassengerCount(),
                'prime': isPrimeView && isPrimeUser ? 'yes' : isPrimeView ? 'no' : 'na',
                'maxdsc': this.getMaxdsc(primeInfo, merchandisingDiscountPercentage),
            });
    },

    onTapSpecialSelectDropdownItem: function(event) {
        event.stopPropagation();
        event.preventDefault();
        this.onSelectBaggage($(event.currentTarget), true);
    },

    onTapSmartnagDesktopContainer: function(event) {
        if (!$(event.target).hasClass('.special_select_dropdown')) {
            this.closeAllSpecialSelectDropdown();
        }
    },

    closeAllSpecialSelectDropdown: function() {
        this.$el.find('.special_select_dropdown').toggleClass('odf-hidden', true);
    },

    showSmartNagBaggage: function() {
        this.loadTemplates();
        this.loadLightbox();
        this.setDefaultIcon(this.model.getPassengerCount());
        this.checkPreselected();
        trackNag('BAGGAGE_ON_CONTINUE');
        const primeInfo = this.getPrimeInfo();
        const {isPrimeView, isPrimeUser} = primeInfo;
        const {displayed: merchandisingDiscountDisplayed = false, discount: merchandisingDiscount = 0}
            = baggageCollectionBuilder.getMerchandisingDiscountInfo();
        const merchandisingDiscountPercentage = merchandisingDiscountDisplayed ? merchandisingDiscount : 0;
        this.trackEvent('nag-baggage-submit_appearances',
            {
                'pax': this.model.getPassengerCount(),
                'prime': isPrimeView && isPrimeUser ? 'yes' : isPrimeView ? 'no' : 'na',
                'maxdsc': this.getMaxdsc(primeInfo, merchandisingDiscountPercentage),
            }, true);
        Odigeo._.delay(Odigeo._.bind(function() {
            this.$cachedSelectors.submitWithSelectionButton.focus();
        }, this), 100);
    },

    loadLightbox: function() {
        this.smartNagLightbox = new Odigeo.UIElements.Lightbox(
            this.$cachedSelectors.smartnagBaggageContainer, {
                closeOnOuterClick: false,
                overFullPage: false,
            });
        this.smartNagLightbox.toggle(true);
    },

    loadTemplates: function() {
        this.templates = Odigeo.Utils.getTemplates(this.$el, this.tmpls);

        this.$el.append(this.templates.mainTemplate(this.model.getMainTemplateData()));

        this.renderSegmentTemplate('collapsed');
        if (this.model.isExpandableTrip()) {
            this.renderSegmentTemplate('departure');
            this.renderSegmentTemplate('return');
        }

        this.updateDomSelectorsToCache();
    },

    renderAllSegmentTemplates: function() {
        this.renderSegmentTemplate('collapsed');
        if (this.model.isExpandableTrip()) {
            this.renderSegmentTemplate('departure');
            this.renderSegmentTemplate('return');
        }
    },
    renderSegmentTemplate: function(segmentType) {
        if (Odigeo._.isObject(this.model.get(segmentType))) {
            this.$el.find(this.selectors[segmentType + 'RowContainer']).html(this.templates.itemTemplate({
                segmentsBaggage: this.model.getSegmentBaggage(segmentType),
                segmentType: segmentType,
                isOneWayTrip: this.model.isOneWayTrip(),
                isExpandableTrip: this.model.isExpandableTrip(),
            }));
        }
    },

    setDefaultIcon: function(numpax) {
        var options = {
            icon: numpax === 1 ? 'no' : 'none',
            title: this.widget.options.translations.titleCollapse,
            subtitle: this.widget.options.translations.subtitle,
        };

        this.drawLeftColumnMessage(options);
    },

    checkPreselected: function() {
        var collapsedPreselectedSegments = this.model.getSelectedSegments('collapsed');
        if (collapsedPreselectedSegments.length) {
            Odigeo._.each(collapsedPreselectedSegments, Odigeo._.bind(function(collapsedPreselectedSegment) {
                this.onSelectBaggage(this.$el.find('.special_select_' + collapsedPreselectedSegment.cid + collapsedPreselectedSegment.cid2), false);
            }, this));
            this.togglePrimaryButton(true);
        }
    },

    expandReturnSection: function() {
        this.$cachedSelectors.collapsedContainer.toggleClass('odf-hidden');
        this.$cachedSelectors.expandedContainer.toggleClass('odf-hidden');
        this.$cachedSelectors.smartnagHeaderImage.toggleClass('odf-hidden');
        this.$cachedSelectors.smartnagHeaderSubtitle.toggleClass('odf-hidden');
        this.$cachedSelectors.expandButtonContainer.toggleClass('odf-hidden');
        this.$cachedSelectors.smartnagTitle.html(this.widget.options.translations.titleExpand);
        this.model.activateExpandedStatus();
    },
    togglePrimaryButton: function(isActivating) {
        this.$cachedSelectors.submitWithSelectionButton.toggleClass('disabled', !isActivating);
    },

    onSelectBaggage: function($el, fromUserEvent) {
        var isPreselectingDesktop = $el.hasClass('special_select_dropdown');
        var isDesktop = $el.hasClass('special_select_dropdown_item');
        var rowType = $el.data('type');
        var idPassenger = $el.data('passenger');
        var selectedOption = isPreselectingDesktop ? $el.find('[data-selected="selected"]') : isDesktop ? $el : $el.find('option:selected');
        var optionCid = selectedOption.data('bag');
        var prevPieces = this.model.getSelectedOptionPieces(rowType, idPassenger);
        this.model.updateBaggageData(rowType, idPassenger, optionCid);
        this.renderAllSegmentTemplates();
        if (fromUserEvent) {
            const primeInfo = this.getPrimeInfo();
            const {isPrimeView, isPrimeUser} = primeInfo;
            const {displayed: merchandisingDiscountDisplayed = false, discount: merchandisingDiscount = 0}
                = baggageCollectionBuilder.getMerchandisingDiscountInfo();
            const merchandisingDiscountPercentage = merchandisingDiscountDisplayed ? merchandisingDiscount : 0;
            this.trackEvent('nag-baggage-submit',
                {
                    'sel': prevPieces === 0 ? 'add' : 'edit',
                    'pax': this.model.getPassengerCount(),
                    'prime': isPrimeView && isPrimeUser ? 'yes' : isPrimeView ? 'no' : 'na',
                    'maxdsc': this.getMaxdsc(primeInfo, merchandisingDiscountPercentage),
                });
        }
    },

    updatePriceLabel: function(totalPrice, totalPrimePrice) {
        const {isPrimeView = false} = baggageOptionsCollection.getPrimeInfo();
        const showPrimeInfo = isPrimeView && totalPrimePrice > 0 && totalPrimePrice < totalPrice;

        this.$cachedSelectors.totalPriceLabel.html('+ ' + Odigeo.Utils.formatCurrency(totalPrice));
        this.$cachedSelectors.totalPrimePriceLabel.html('+ ' + Odigeo.Utils.formatCurrency(totalPrimePrice));
        this.$cachedSelectors.totalPriceLabel.toggleClass('odf-text-soft', showPrimeInfo);
        this.$cachedSelectors.totalPriceLabel.toggleClass('odf-text-line-through', showPrimeInfo);
        this.$cachedSelectors.totalPrimePriceLabel.toggleClass('odf-hidden', !showPrimeInfo);

        this.togglePrimaryButton(totalPrice > 0);
    },

    getSuccessMessageOptions: function() {
        var options = {};
        var allPassengersHaveBags;
        if (this.model.getPassengerCount() === 1) {
            options = {
                title: this.widget.options.translations.success1Pax,
                subtitle: '',
                icon: 'yes',
            };
        } else {
            allPassengersHaveBags = this.model.allPassengersHaveSelectedBaggage();
            options = {
                title: allPassengersHaveBags ? this.widget.options.translations.successallPax
                    : this.widget.options.translations.success1Pax,
                subtitle: '',
                icon: allPassengersHaveBags ? 'both' : 'extend',
            };
        }
        return options;
    },

    setSuccessMessage: function() {
        var options = {};
        if (this.model.getPassengerCount() === 1) {
            options = {
                title: this.widget.options.translations.success1Pax,
                subtitle: '',
                icon: 'yes',
            };
        } else {
            options = this.getSuccessMessageOptions();
        }
        this.drawLeftColumnMessage(options);
    },

    drawLeftColumnMessage: function(options) {
        this.$cachedSelectors.smartnagPaxIcon.removeClass(function(index, className) {
            return (className.match(/\bodf-spot-bags-\S+/g) || []).join(' ');
        });
        this.$cachedSelectors.smartnagPaxIcon.addClass('odf-spot-bags-' + options.icon);
        this.$cachedSelectors.smartnagTitleWrapper.html(options.title);
        this.$cachedSelectors.smartnagSubtitleWrapper.html(options.subtitle);
    },

    showSuccessMessage: function() {
        this.$cachedSelectors.smartnagBaggageContent.toggleClass('odf-hidden');
        this.$cachedSelectors.smartnagSuccess.toggleClass('odf-hidden');
    },

    getFlightBagAdded: function(rowType, flightType) {
        var flightBagAdded = this.trackingConst.return;
        if (rowType === 'collapsed' && flightType !== 'OW') {
            flightBagAdded = this.trackingConst.allSegments;
        } else if (rowType === 'departure' || flightType === 'OW') {
            flightBagAdded = this.trackingConst.departure;
        }
        return flightBagAdded;
    },

    trackEvent: function(label, params) {
        Odigeo._.each(params, function(value, key) {
            label += '_' + key + ':' + value;
        });
        trackingUtils.trackEvent('nags', label, Odigeo.History.getPageNameFromFragment());
    },
}));
